import { useHistory } from 'react-router-dom';
import useHousingStockMatch from '../containers/HousingStock/hooks/useHousingStockMatch';
import { useSelector } from 'react-redux';
import { links } from '../containers/HousingStock/constants/links';
import { useCallback, useMemo } from 'react';

const useCompanyId = (match) => {
  const currentCompanyId = useSelector(
    (state) => state.housingStockStore.currentCompany?.id
  );

  return useMemo(() => {
    return match?.params?.companyId || currentCompanyId;
  }, [match?.params?.companyId, currentCompanyId]);
};

const useIsHousingStockPage = () => {
  const match = useHousingStockMatch();

  return Boolean(match);
};

const useResetHsPage = () => {
  const history = useHistory();

  const match = useHousingStockMatch();

  const companyId = useCompanyId(match);
  const isHousingStockPage = useIsHousingStockPage();

  const resetHsPage = useCallback(() => {
    if (!isHousingStockPage) return;
    if (!companyId) return;

    history.push(`${links.rootWithCompany}/${companyId}/${links.houses}`);
  }, [isHousingStockPage, companyId, history]);

  return resetHsPage;
};

export default useResetHsPage;
